import React from 'react';
import { motion } from 'framer-motion';
import { Tilt } from 'react-tilt';
import { FaCode } from 'react-icons/fa6';
import { FaEye } from 'react-icons/fa';
import { useInView } from 'react-intersection-observer';

const ProjectCard = ({ imgUrl, title, desc, github, live, tags }) => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <Tilt className="Tilt" options={{ scale: 1.05, max: 30, perspective: 1000 }}>
      <div className="relative">
        <motion.div
          className="h-52 md:h-44 rounded-t-xl relative group overflow-hidden"
          initial={{ opacity: 0, x: -200 }}
          animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -200 }}
          transition={{ duration: 1 }}
          ref={ref}
        >
          <img 
            src={imgUrl} 
            alt={`${title} - Project Preview`} 
            className="w-full h-full object-cover"
          />
          <div className="overlay absolute top-0 left-0 h-full w-full bg-[#181818] bg-opacity-0 hidden group-hover:flex group-hover:bg-opacity-80 cursor-pointer transition-all duration-500 rounded-t-xl justify-center items-center">
            <div className="flex justify-center items-center gap-9 w-full h-full">
              {github && (
                <motion.button
                  className="text-white border border-white p-3 rounded-full"
                  whileHover={{ scale: 1.1 }}
                  aria-label={`View ${title} source code on GitHub`}
                >
                  <a href={github} target="_blank" rel="noreferrer">
                    <FaCode size={25} />
                  </a>
                </motion.button>
              )}
              {live && (
                <motion.button
                  className="text-white border border-white p-3 rounded-full"
                  whileHover={{ scale: 1.1 }}
                  aria-label={`View ${title} live demo`}
                >
                  <a href={live} target="_blank" rel="noreferrer">
                    <FaEye size={25} />
                  </a>
                </motion.button>
              )}
              {!github && !live && (
                <span className="text-white font-medium">Internal Project</span>
              )}
            </div>
          </div>
        </motion.div>
        <motion.div
          className="text-white rounded-b-xl bg-[#181818] px-4 py-4"
          initial={{ opacity: 0, y: 0 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 200 }}
          transition={{ duration: 1 }}
          ref={ref}
        >
          <div className="flex justify-between items-start">
            <h3 className="text-xl font-semibold ">{title}</h3>
            {tags?.featured && (
              <span className="text-[10px] bg-[#F16A6A] text-white px-2 py-1 rounded-full animate-pulse whitespace-nowrap ml-2">
                {tags.featured}
              </span>
            )}
          </div>
          <p className="text-gray-500 mt-2">{desc}</p>
        </motion.div>
      </div>
    </Tilt>
  );
};

export default ProjectCard;
